import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'kp-screen-initial',
  templateUrl: './screen-initial.component.html',
  styleUrls: ['./screen-initial.component.scss'],
})
export class ScreenInitialComponent implements OnInit {
  groupCode;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.groupCode = this.route.snapshot.params['groupCode'];
  }
}
